<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <div class="flex flex_warp">
        <div class="flex flex_items mr10 mb10"><span>订单号：</span><el-input placeholder="请输入" class="s-input"
            v-model="order_no"></el-input></div>
        <template v-if="activeName == 2">
          <div class="flex flex_items mr10 mb10"><span>会员姓名：</span><el-input placeholder="请输入" class="s-input"
              v-model="tourist_name"></el-input></div>
          <div class="flex flex_items mr10 mb10"><span>会员电话：</span><el-input placeholder="请输入" class="s-input"
              v-model="tourist_phone"></el-input></div>
          <div class="flex flex_items mr10 mb10"><span>会员证件号：</span><el-input placeholder="请输入" class="s-input"
              v-model="tourist_code"></el-input></div>
        </template>


        <el-date-picker v-model="timeArr" type="daterange" range-separator="至" start-placeholder="开始日期"
          class="mr20 mb10" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary" class="mb10" @click="search">搜索</el-button>
      </div>


      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="门票订单" name="1" v-if="role.includes('v1.window.order.ticket')">
          <tickets ref="tickets" :endTime="endTime" :startTime="startTime" :order_no="order_no"></tickets>
        </el-tab-pane>
        <el-tab-pane label="年卡订单" name="2" v-if="role.includes('v1.window.order.yearCard')">
          <yearCard ref="yearCard" :endTime="endTime" :startTime="startTime" :order_no="order_no"
            :tourist_name="tourist_name" :tourist_phone="tourist_phone" :tourist_code="tourist_code"></yearCard>
        </el-tab-pane>
      </el-tabs>




    </div>

  </div>
</template>
<script>
import tickets from './compoenets/tickets.vue';
import yearCard from './compoenets/yearCard.vue';
import { parseTime } from "@/utils/index"

export default {
  data() {
    return {
      list: [],
      role: [],
      check: 0,
      dialogVisible: false,
      total: 0,
      currentPage: 1,
      keyword: '',
      choseArr: [],
      val: '',
      handleId: '',

      query: {},
      id: '',
      type: '1',
      remarks: '',
      value1: '',
      endTime: '',
      startTime: '',
      activeName: '1',
      timeArr: [],
      order_no: '',
      tourist_name: '',
      tourist_phone: '',
      tourist_code: ''
    };
  },
  components: { tickets, yearCard },
  watch: {},
  methods: {
    addNew() {
      this.handleId = '';
      this.val = '';
      this.dialogVisible = true
    },
    handleClick(tab, event) {
      this.$nextTick(_ => {
        if (this.activeName == 1) {
          this.$refs.tickets.resetData()
        } else {
          this.$refs.yearCard.resetData()
        }
      })
    },
    handleSelectionChange(e) {
      this.choseArr = e;
    },
    search() {
      this.startTime = parseTime(this.timeArr[0], '{y}-{m}-{d}');
      this.endTime = parseTime(this.timeArr[1], '{y}-{m}-{d}');
      this.$nextTick(r => {
        if (this.activeName == 1) {
          this.$refs.tickets.resetData()
        } else {
          this.$refs.yearCard.resetData()
        }
      })
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.role = this.$store.getters.roles ? this.$store.getters.roles : [];
    this.query = this.$route.query;
    this.timeArr = [new Date(), new Date()];
    this.startTime = parseTime(new Date(), '{y}-{m}-{d}');
    this.endTime = parseTime(new Date(), '{y}-{m}-{d}');
    this.$nextTick(_ => {
      if (this.role.includes('v1.window.order.ticket')) {
        this.activeName = '1'
        // if(this.$route.query.search) 
        this.$refs.tickets.resetData()
      } else {
        this.activeName = '2'
        this.$refs.yearCard.resetData()
      }
    })
  },
};
</script>
<style scoped>
.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.page_title {
  margin-bottom: 24px;
}

.label.label1 {
  color: #67C23A;
  background: rgba(103, 194, 58, .29);
}

.label {
  padding: 2px 6px;
  background: rgba(64, 158, 255, .29);
  border-radius: 4px;
}

.t-btn {
  margin-right: 40px;
  position: relative;
}

.t-btn.main_color::after {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #409EFF;
  content: " ";
}

.s-icon {
  border-radius: 4px 4px 4px 4px;
  padding: 2px 7px;
}

.s-icon1 {
  background: rgba(64, 158, 255, .29);
  color: rgba(64, 158, 255, 1);
}

.s-icon2 {
  background: rgba(245, 108, 108, .29);
  color: rgba(245, 108, 108, 1);
}

.s-input {
  width: 200px;
}
</style>
<style>
.el-progress__text {
  font-size: 13px !important;
}
</style>